import type { SubquestionsType } from "../model";

export const sendProgram = async (
  question: SubquestionsType[],
  dialogueId: string | null,
) => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_AI_API_URL}/program`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        questions: [...question],
        dialogue_id: dialogueId,
      }),
    },
  );

  const data = await response.json();
  return data;
};
